export default __webpack_public_path__ + "static/media/noPosterSmall.8051b545.png";